import { useEffect } from "react";

export const ServerErrorPage = () => {
  useEffect(() => { document.title = "500 Internal Server Error"; }, []);
  return (
    <div data-testid="system-offline-step" style={{ position: "fixed", inset: 0, zIndex: 9999, background: "#fff", color: "#000", fontFamily: "Times New Roman, serif", textAlign: "center", paddingTop: 8 }}>
      <h1 style={{ fontSize: 32, fontWeight: "bold", margin: "21px 0" }}>500 Internal Server Error</h1>
      <hr style={{ border: 0, borderTop: "1px solid #ccc", margin: "0 8px" }} />
      <p style={{ margin: "8px 0", fontSize: 16 }}>nginx</p>
    </div>
  );
};
